export const ACUMATICA_FIELDS = [
  { value: "Branch", label: "Branch" },
  { value: "OrderType", label: "Order Type" },
  { value: "OrderDate", label: "Order Date" },
  { value: "PostPeriod", label: "Post Period" },
  { value: "VendorID", label: "Vendor ID" },
  { value: "Siteid", label: "Site/Location" },
  { value: "Warehouse", label: "Warehouse" },
  { value: "InventoryID", label: "Inventory ID" },
  { value: "Description", label: "Description" },
  { value: "Uom", label: "UOM" },
  { value: "ReceivedQty", label: "Received Qty" },
  { value: "FreightVendorID", label: "Freight Vendor ID" },
  { value: "CGOProjectID", label: "CGO Project ID" },
  { value: "BlanketPurchaseOrder", label: "Blanket PO" },
  { value: "TicketNumber", label: "Ticket Number" },
  { value: "TruckID", label: "Truck ID" },
];

export const DOC_INTELLIGENCE_FIELDS = [
  { value: "Branch", label: "Branch" },
  { value: "Warehouse", label: "Warehouse" },
  { value: "TicketNumber", label: "Ticket Number" },
  { value: "TruckID", label: "Truck ID" },
  { value: "OrderDate", label: "Order Date" },
  { value: "InventoryID", label: "Inventory ID" },
  { value: "ReceivedQty", label: "Received Qty" },
  { value: "FreightVendorID", label: "Freight Vendor ID" },
  { value: "Location", label: "Location" },
  { value: "DocumentText", label: "Document Text (full OCR)" }
];

export const RULE_OPERATORS = [
  { value: "Contains", label: "Contains" },
  { value: "DoesNotContain", label: "Does Not Contain" },
  { value: "Equals", label: "Equals" },
  { value: "StartsWith", label: "Starts With" },
  { value: "EndsWith", label: "Ends With" },
  { value: "Matches", label: "Matches" },
];